import { Router } from 'expo-router';

import { routes } from 'utils/routing';

type NavigateToUnavailableFullMenuOptions = {
  /** Missing/empty section — pins that category on Full Menu. */
  sectionId?: string;
  /**
   * Unavailable item/combo/picker whose parent section is missing at the store —
   * pins the product Not Available card above other available options.
   */
  itemId?: string;
};

/**
 * Opens Full Menu with unavailable recovery chrome.
 * Prefer `itemId` when a product card should lead; `sectionId` pins a category.
 */
export function navigateToUnavailableFullMenu(
  router: Pick<Router, 'canDismiss' | 'dismissTo' | 'replace'>,
  sectionIdOrOptions: string | NavigateToUnavailableFullMenuOptions
): void {
  const options: NavigateToUnavailableFullMenuOptions =
    typeof sectionIdOrOptions === 'string' ? { sectionId: sectionIdOrOptions } : sectionIdOrOptions;

  const params: Record<string, string> = {};
  if (options.sectionId) {
    params.unavailableSectionId = options.sectionId;
  }
  if (options.itemId) {
    params.unavailableItemId = options.itemId;
  }

  const route = {
    pathname: routes.menu as '/menu',
    params,
  };

  if (router.canDismiss()) {
    router.dismissTo(route);
    return;
  }

  router.replace(route);
}
